const $$splitErrorComponentImporter = () => import('/app/apps/webapp/src/app/routes/_authenticated/resources/meals/$savedMealId.tsx?tsr-split=errorComponent');
const $$splitComponentImporter = () => import('/app/apps/webapp/src/app/routes/_authenticated/resources/meals/$savedMealId.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { rethrowUnlessUnauthorized } from '@/app/lib/redirect-to-login';
import { getSavedMealQuery } from '@/features/saved-meals/lib/get-saved-meal.query';
import { RECENT_LINE_INGREDIENTS_FETCH_LIMIT } from '@/features/saved-meals/lib/constants';
import { listRecentLineIngredientsQuery } from '@/features/saved-meals/lib/list-recent-line-ingredients.query';
export const Route = createFileRoute('/_authenticated/resources/meals/$savedMealId')({
  beforeLoad: ({
    context,
    params
  }) => {
    const validated = context.deps.validators.savedMealIdValidator.validate(params.savedMealId);
    if (!validated.ok) {
      throw redirect({
        to: '/resources/meals'
      });
    }
    return {
      savedMealId: validated.data
    };
  },
  loader: async ({
    context,
    location
  }) => {
    try {
      await context.queryClient.ensureQueryData(getSavedMealQuery({
        controllers: {
          savedMealController: context.deps.controllers.savedMealController
        }
      }, context.savedMealId));
      // Warms the Search tab's Recent list; not awaited so it never blocks the page.
      void context.queryClient.prefetchQuery(listRecentLineIngredientsQuery({
        controllers: {
          savedMealController: context.deps.controllers.savedMealController
        }
      }, RECENT_LINE_INGREDIENTS_FETCH_LIMIT));
    } catch (error) {
      await rethrowUnlessUnauthorized(error, context.queryClient, `${location.pathname}${location.searchStr}`);
    }
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  errorComponent: lazyRouteComponent($$splitErrorComponentImporter, 'errorComponent')
});